// extracted by mini-css-extract-plugin
export default {"steps":"_1Ld2XBsR","stepWrapper":"_15Es1rjL","step":"_1VrLyU0d","hotels":"_1_qMHV6a"};